import { ListLoaderWrapper } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"
import { ExpenseTypeList } from "./expenseTypeList"

export const ExpenseTypeListLoader = () => (
  <ListLoaderWrapper table={TableName.EXPENSE_TYPES}>
    <ExpenseTypeList />
  </ListLoaderWrapper>
)
